import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ArticleModule } from '@modules/article/article.module';
import { CardModule } from '@modules/card/card.module';
import { UiModule } from '@modules/ui/ui.module';

import { NewsletterSubscribeComponent } from './components/subscribe.component';
import { NewsletterUnsubscribeComponent } from './components/unsubscribe.component';
import { NewsletterRoutingModule } from './newsletter-routing.module';

@NgModule({
  imports: [
    CommonModule,
    ArticleModule,
    NewsletterRoutingModule,
    CardModule,
    UiModule,
    NewsletterSubscribeComponent,
    NewsletterUnsubscribeComponent,
  ],
})
export class NewsletterPageModule {}
